declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const GA_ID = 'G-Z7Q6557DFX';

export function hasConsent(): boolean {
  return localStorage.getItem('cookie_consent') === 'accepted';
}

export function initGA(): void {
  if (!hasConsent()) return;
  if (document.getElementById('ga-script')) return;

  // Load gtag.js
  const script = document.createElement('script');
  script.id = 'ga-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  // Configure
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // send_page_view:false because this is a single-page app. gtag's automatic
  // page_view fires once, for whatever URL the visitor first landed on, and
  // never again — every in-app navigation after that was invisible. Views are
  // now emitted by AnalyticsRouteTracker instead, which sees route changes.
  window.gtag('config', GA_ID, { anonymize_ip: true, send_page_view: false });

  // GA only loads once cookie consent is accepted, which can happen well after
  // the first route rendered. Announce readiness so the tracker can send the
  // view the visitor is already looking at, instead of losing it.
  window.dispatchEvent(new Event('ga:ready'));
}

// Guard against the same path being sent twice in quick succession — the
// consent handshake above can race the router's own mount effect.
let lastPath: string | null = null;
let lastAt = 0;

export function trackPageView(path?: string): void {
  if (typeof window.gtag !== 'function') return;
  const p = path ?? window.location.pathname + window.location.search;
  const now = Date.now();
  if (p === lastPath && now - lastAt < 1000) return;
  lastPath = p;
  lastAt = now;
  window.gtag('event', 'page_view', {
    page_path: p,
    page_location: window.location.origin + p,
    page_title: document.title,
  });
}

export function trackEvent(eventName: string, params?: Record<string, any>): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}
